<template>
  <div v-if="!angemeldeterMitarbeiter" class="container-fluid tile-container">
    <div v-if="!showPasskeyVerify && !showPasskeySetup && !showPasskeyBackup" class="row mt-70-px justify-content-center">
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <div class="tile-categorie-frame">
              <div class="tile-categorie">
                <div class="text-right m-4">
                  <div class="language-selection">
                    <b-button
                      variant="outline-primary"
                      class="mx-1"
                      size="sm"
                      @click="language = 'de'"
                      :class="language === 'de' ? 'active' : ''"
                      >DE</b-button
                    >
                    <b-button
                      variant="outline-primary"
                      class="mr-1"
                      size="sm"
                      @click="language = 'en'"
                      :class="language === 'en' ? 'active' : ''"
                      >EN</b-button
                    >
                    <b-button
                      variant="outline-primary"
                      class="mr-1"
                      size="sm"
                      @click="language = 'fr'"
                      :class="language === 'fr' ? 'active' : ''"
                      >FR</b-button
                    >
                    <b-button
                      variant="outline-primary"
                      class="mr-1"
                      size="sm"
                      @click="language = 'it'"
                      :class="language === 'it' ? 'active' : ''"
                      >IT</b-button
                    >
                  </div>
                </div>
                <div class="header text-center">
                  <span>{{ welcome[language] }}</span>
                </div>
                <div v-if="isDevelopment" class="text-center mb-2">
                  <small class="text-muted">
                    <font-awesome-icon icon="fa-solid fa-plug" class="mr-1" />
                    {{ serverUrl }}
                  </small>
                </div>
                <div class="m-4">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span id="username" class="input-group-text">
                        <font-awesome-icon
                          icon="fa-duotone fa-user"
                          aria-hidden="true"
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      name="username"
                      class="form-control"
                      :placeholder="usernameSprachvariable[language]"
                      aria-describedby="username"
                      autofocus
                      autocapitalize="off"
                      spellcheck="false"
                      autocorrect="off"
                      v-model="username"
                      @keydown="checkCapsLock"
                    />
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span id="password" class="input-group-text">
                        <font-awesome-icon
                          icon="fa-duotone fa-key"
                          aria-hidden="true"
                        />
                      </span>
                    </div>
                    <input
                      type="password"
                      name="password"
                      class="form-control"
                      :placeholder="passwordSprachvariable[language]"
                      aria-describedby="password"
                      autocomplete="off"
                      autocapitalize="off"
                      spellcheck="false"
                      autocorrect="off"
                      v-model="password"
                      @keyup.enter="login"
                      @keydown="checkCapsLock"
                    />
                  </div>
                  <p v-if="isCapsLockOn" style="color: red">
                    {{ capslockactivated[language] }}
                  </p>
                  <button class="btn btn-primary w-100 mb-3" @click="login" :disabled="loggingIn">
                    {{ loginSprachvariable[language] }}
                  </button>
                  <div v-if="passkeySupported" class="d-flex align-items-center mb-3" style="gap: 8px; opacity: 0.5; font-size: 0.85rem">
                    <div style="flex: 1; border-top: 1px solid currentColor"></div>
                    {{ passkeyLabels.orDivider[language] }}
                    <div style="flex: 1; border-top: 1px solid currentColor"></div>
                  </div>
                  <button v-if="passkeySupported" class="btn btn-outline-primary w-100 mb-3" @click="loginWithPasskey" :disabled="loggingIn || passkeyLoading">
                    <span v-if="passkeyLoading" class="spinner-border spinner-border-sm mr-2" />
                    <font-awesome-icon v-else icon="fa-regular fa-key" class="mr-2" />
                    {{ passkeyLabels.loginBtn[language] }}
                  </button>
                  <div v-if="loginError" class="alert alert-danger py-2 mb-2" style="font-size: 0.875rem">
                    {{ loginFailed[language] }}
                  </div>
                  <div
                    class="hover-medium-blue d-inline-block"
                    style="cursor: pointer"
                    @click="navigateToResetPW"
                  >
                    {{ forgottenyourpassword[language] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <!-- MFA: choose method -->
      <div v-if="showMfaChoice" class="row mt-70-px justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-4">
          <div class="tile-categorie-frame"><div class="tile-categorie">
            <div class="header text-center m-4">{{ mfaChoiceLabels.title[language] }}</div>
            <div class="m-4">
              <p class="text-muted small">{{ mfaChoiceLabels.desc[language] }}</p>
              <button
                v-if="mfaMethods.includes('passkey')"
                class="btn btn-primary w-100 mb-2"
                @click="chooseMfa('passkey')"
              >
                <font-awesome-icon icon="fa-regular fa-key" class="mr-2" />
                {{ mfaChoiceLabels.passkey[language] }}
              </button>
              <button
                v-if="mfaMethods.includes('totp')"
                class="btn btn-primary w-100 mb-2"
                @click="chooseMfa('totp')"
              >
                <font-awesome-icon icon="fa-regular fa-mobile-screen" class="mr-2" />
                {{ mfaChoiceLabels.totp[language] }}
              </button>
              <button
                v-if="mfaMethods.includes('passkey_setup')"
                class="btn btn-outline-primary w-100 mb-2"
                @click="chooseMfa('passkey_setup')"
              >
                <font-awesome-icon icon="fa-regular fa-key" class="mr-2" />
                {{ mfaChoiceLabels.passkeySetup[language] }}
              </button>
              <button
                v-if="mfaMethods.includes('totp_setup')"
                class="btn btn-outline-primary w-100 mb-2"
                @click="chooseMfa('totp_setup')"
              >
                <font-awesome-icon icon="fa-regular fa-mobile-screen" class="mr-2" />
                {{ mfaChoiceLabels.totpSetup[language] }}
              </button>
            </div>
          </div></div>
        </div>
      </div>

      <!-- MFA: verify existing passkey -->
      <div v-if="showPasskeyVerify" class="row mt-70-px justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-4">
          <div class="tile-categorie-frame"><div class="tile-categorie">
            <div class="header text-center m-4">{{ passkeyLabels.verify[language] }}</div>
            <div class="m-4">
              <p class="text-muted small">{{ passkeyLabels.verifyDesc[language] }}</p>
              <p v-if="passkeyError" class="text-danger small">{{ passkeyLabels.failed[language] }}</p>
              <button class="btn btn-primary w-100 mb-2" @click="verifyPasskey" :disabled="passkeyLoading">
                <span v-if="passkeyLoading" class="spinner-border spinner-border-sm mr-2" />
                {{ passkeyLabels.verifyBtn[language] }}
              </button>
              <button class="btn btn-outline-secondary w-100" @click="verifyPasskeyOtherDevice" :disabled="passkeyLoading">
                {{ passkeyLabels.verifyOtherBtn[language] }}
              </button>
            </div>
          </div></div>
        </div>
      </div>

      <!-- MFA: set up first passkey -->
      <div v-if="showPasskeySetup" class="row mt-70-px justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-4">
          <div class="tile-categorie-frame"><div class="tile-categorie">
            <div class="header text-center m-4">{{ passkeyLabels.setup[language] }}</div>
            <div class="m-4">
              <p class="text-muted small">{{ passkeyLabels.setupDesc[language] }}</p>
              <p v-if="passkeyError" class="text-danger small">{{ passkeyLabels.failed[language] }}</p>
              <button class="btn btn-primary w-100" @click="setupPasskey" :disabled="passkeyLoading">
                <span v-if="passkeyLoading" class="spinner-border spinner-border-sm mr-2" />
                {{ passkeyLabels.setupBtn[language] }}
              </button>
            </div>
          </div></div>
        </div>
      </div>

      <!-- MFA: TOTP verify -->
      <div v-if="showTotpVerify" class="row mt-70-px justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-4">
          <div class="tile-categorie-frame"><div class="tile-categorie">
            <div class="header text-center m-4">{{ totpLabels.verify[language] }}</div>
            <div class="m-4">
              <p class="text-muted small">{{ totpLabels.verifyDesc[language] }}</p>
              <input
                v-model="totpCode"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="6"
                class="form-control mb-3 text-center"
                style="font-size: 1.5rem; letter-spacing: 0.3em"
                :placeholder="totpLabels.codePlaceholder[language]"
                @keyup.enter="verifyTotp"
              />
              <p v-if="totpError" class="text-danger small">{{ totpLabels.failed[language] }}</p>
              <button class="btn btn-primary w-100" @click="verifyTotp" :disabled="totpLoading || totpCode.length !== 6">
                <span v-if="totpLoading" class="spinner-border spinner-border-sm mr-2" />
                {{ totpLabels.verifyBtn[language] }}
              </button>
            </div>
          </div></div>
        </div>
      </div>

      <!-- MFA: TOTP setup (first time) -->
      <div v-if="showTotpSetup" class="row mt-70-px justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-4">
          <div class="tile-categorie-frame"><div class="tile-categorie">
            <div class="header text-center m-4">{{ totpLabels.setup[language] }}</div>
            <div class="m-4">
              <p class="text-muted small">{{ totpLabels.setupDesc[language] }}</p>
              <div v-if="totpOtpauthUri" class="text-center mb-3">
                <canvas ref="totpQrCanvas" style="max-width: 200px; width: 100%"></canvas>
                <p class="text-muted" style="font-size: 0.75rem; word-break: break-all; margin-top: 8px">
                  {{ totpLabels.manualKey[language] }}: <strong>{{ totpSecret }}</strong>
                </p>
              </div>
              <input
                v-if="totpOtpauthUri"
                v-model="totpCode"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="6"
                class="form-control mb-3 text-center"
                style="font-size: 1.5rem; letter-spacing: 0.3em"
                :placeholder="totpLabels.codePlaceholder[language]"
                @keyup.enter="confirmTotpSetup"
              />
              <p v-if="totpError" class="text-danger small">{{ totpLabels.failed[language] }}</p>
              <button v-if="!totpOtpauthUri" class="btn btn-primary w-100" @click="startTotpSetup" :disabled="totpLoading">
                <span v-if="totpLoading" class="spinner-border spinner-border-sm mr-2" />
                {{ totpLabels.setupBtn[language] }}
              </button>
              <button v-if="totpOtpauthUri" class="btn btn-primary w-100" @click="confirmTotpSetup" :disabled="totpLoading || totpCode.length !== 6">
                <span v-if="totpLoading" class="spinner-border spinner-border-sm mr-2" />
                {{ totpLabels.confirmBtn[language] }}
              </button>
            </div>
          </div></div>
        </div>
      </div>

      <!-- MFA: optional backup passkey (phone) after first setup -->
      <div v-if="showPasskeyBackup" class="row mt-70-px justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-4">
          <div class="tile-categorie-frame"><div class="tile-categorie">
            <div class="header text-center m-4">{{ passkeyLabels.backup[language] }}</div>
            <div class="m-4">
              <p class="text-muted small">{{ passkeyLabels.backupDesc[language] }}</p>
              <p v-if="passkeyError" class="text-danger small">{{ passkeyLabels.failed[language] }}</p>
              <button class="btn btn-primary w-100 mb-2" @click="addBackupPasskey" :disabled="passkeyLoading">
                <span v-if="passkeyLoading" class="spinner-border spinner-border-sm mr-2" />
                {{ passkeyLabels.backupBtn[language] }}
              </button>
              <button class="btn btn-outline-secondary w-100" @click="goToApp" :disabled="passkeyLoading">
                {{ passkeyLabels.skip[language] }}
              </button>
            </div>
          </div></div>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import PublicAppApi from "@/api/PublicAppApi";
import { bufferToBase64url, base64urlToBuffer, isPasskeySupported } from "@/utils/Passkey";


export default {
  name: "Login",
  data() {
    return {
      username: null,
      password: null,
      isCapsLockOn: false,
      loggingIn: false,
      loginError: false,
      language: null,
      passkeyMfaEnabled: false,
      showMfaChoice: false,
      mfaMethods: [],
      showPasskeyVerify: false,
      showPasskeySetup: false,
      showPasskeyBackup: false,
      passkeyLoading: false,
      passkeyError: false,
      showTotpVerify: false,
      showTotpSetup: false,
      totpLoading: false,
      totpError: false,
      totpCode: "",
      totpSecret: "",
      totpOtpauthUri: "",
      passkeyLabels: {
        verify:     { de: "Identität bestätigen",      en: "Confirm identity",     fr: "Confirmer l'identité",  it: "Conferma identità" },
        verifyDesc: { de: "Bestätigen Sie sich mit Ihrem Passkey (Fingerabdruck, Face ID oder PIN).", en: "Confirm with your passkey (fingerprint, Face ID or PIN).", fr: "Confirmez avec votre clé d'accès.", it: "Conferma con la tua chiave di accesso." },
        verifyBtn:      { de: "Mit Passkey bestätigen",        en: "Confirm with passkey",         fr: "Confirmer avec la clé",          it: "Conferma con passkey" },
        verifyOtherBtn: { de: "Anderes Gerät verwenden",        en: "Use a different device",       fr: "Utiliser un autre appareil",     it: "Usa un altro dispositivo" },
        setup:      { de: "Passkey einrichten",        en: "Set up passkey",       fr: "Configurer la clé",     it: "Configura passkey" },
        setupDesc:  { de: "Für Ihre Sicherheit richten Sie jetzt einen Passkey ein.", en: "For your security, set up a passkey now.", fr: "Pour votre sécurité, configurez une clé d'accès.", it: "Per la tua sicurezza, configura ora un passkey." },
        setupBtn:   { de: "Passkey jetzt einrichten", en: "Set up now",            fr: "Configurer maintenant", it: "Configura ora" },
        backup:     { de: "Backup-Passkey hinzufügen", en: "Add backup passkey",   fr: "Ajouter une clé de sauvegarde", it: "Aggiungi passkey di backup" },
        backupDesc: { de: "Empfehlung: Richten Sie auch Ihr Telefon als Backup-Passkey ein. Falls ein Passwortmanager-Dialog erscheint, diesen abbrechen – danach erscheint die Option, ein Telefon per QR-Code hinzuzufügen.", en: "Recommendation: also set up your phone as a backup passkey. If a password manager dialog appears, dismiss it — the option to add a phone via QR code will then appear.", fr: "Recommandation: configurez aussi votre téléphone. Si une fenêtre de gestionnaire de mots de passe apparaît, fermez-la — l'option QR code apparaîtra ensuite.", it: "Raccomandazione: configura anche il telefono. Se appare un gestore di password, chiudilo — apparirà l'opzione QR code." },
        backupBtn:  { de: "Telefon hinzufügen",       en: "Add phone",            fr: "Ajouter le téléphone",  it: "Aggiungi telefono" },
        failed:     { de: "Passkey fehlgeschlagen. Bitte erneut versuchen.", en: "Passkey failed. Please try again.", fr: "Échec de la clé. Réessayez.", it: "Passkey non riuscito. Riprovare." },
        skip:       { de: "Überspringen",             en: "Skip",                 fr: "Ignorer",               it: "Salta" },
        loginBtn:   { de: "Mit Passkey anmelden",     en: "Sign in with passkey", fr: "Se connecter avec la clé", it: "Accedi con passkey" },
        orDivider:  { de: "oder",                     en: "or",                   fr: "ou",                    it: "oppure" },
      },
      mfaChoiceLabels: {
        title:       { de: "Anmeldung bestätigen",              en: "Confirm sign-in",              fr: "Confirmer la connexion",          it: "Conferma accesso" },
        desc:        { de: "Wählen Sie eine Methode zur Bestätigung Ihrer Identität.", en: "Choose a method to confirm your identity.", fr: "Choisissez une méthode pour confirmer votre identité.", it: "Scegli un metodo per confermare la tua identità." },
        passkey:     { de: "Mit Passkey bestätigen",            en: "Confirm with passkey",         fr: "Confirmer avec la clé d'accès",   it: "Conferma con passkey" },
        totp:        { de: "Mit Authenticator-App bestätigen",  en: "Confirm with authenticator",   fr: "Confirmer avec l'authentificateur", it: "Conferma con autenticatore" },
        passkeySetup:{ de: "Passkey einrichten",                en: "Set up passkey",               fr: "Configurer la clé d'accès",       it: "Configura passkey" },
        totpSetup:   { de: "Authenticator-App einrichten",      en: "Set up authenticator",         fr: "Configurer l'authentificateur",   it: "Configura autenticatore" },
      },
      totpLabels: {
        verify:          { de: "Zwei-Faktor-Authentifizierung",  en: "Two-factor authentication",       fr: "Authentification à deux facteurs", it: "Autenticazione a due fattori" },
        verifyDesc:      { de: "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.", en: "Enter the 6-digit code from your authenticator app.", fr: "Entrez le code à 6 chiffres de votre application.", it: "Inserisci il codice a 6 cifre dalla tua app." },
        verifyBtn:       { de: "Bestätigen",                     en: "Confirm",                         fr: "Confirmer",                        it: "Conferma" },
        setup:           { de: "Authenticator einrichten",       en: "Set up authenticator",            fr: "Configurer l'authentificateur",    it: "Configura autenticatore" },
        setupDesc:       { de: "Scannen Sie den QR-Code mit Ihrer Authenticator-App (z. B. Google Authenticator, Microsoft Authenticator, Authy).", en: "Scan the QR code with your authenticator app (e.g. Google Authenticator, Microsoft Authenticator, Authy).", fr: "Scannez le code QR avec votre application.", it: "Scansiona il QR code con la tua app." },
        setupBtn:        { de: "QR-Code anzeigen",               en: "Show QR code",                    fr: "Afficher le code QR",              it: "Mostra QR code" },
        confirmBtn:      { de: "Code bestätigen",                en: "Confirm code",                    fr: "Confirmer le code",                it: "Conferma codice" },
        manualKey:       { de: "Oder manuell eingeben",          en: "Or enter manually",               fr: "Ou saisir manuellement",           it: "O inserisci manualmente" },
        codePlaceholder: { de: "000000",                         en: "000000",                          fr: "000000",                           it: "000000" },
        failed:          { de: "Ungültiger Code. Bitte erneut versuchen.", en: "Invalid code. Please try again.", fr: "Code invalide. Réessayez.", it: "Codice non valido. Riprova." },
      },
      welcome: {
        de: "Willkommen",
        en: "Welcome",
        fr: "Bienvenue",
        it: "Benvenuti",
      },
      usernameSprachvariable: {
        de: "Benutzername",
        en: "User name",
        fr: "Nom d'utilisateur",
        it: "Nome utente",
      },
      passwordSprachvariable: {
        de: "Passwort",
        en: "Password",
        fr: "Mot de passe",
        it: "Password",
      },
      capslockactivated: {
        de: "Caps Lock ist aktiviert!",
        en: "Caps Lock is activated!",
        fr: "Caps Lock est activé !",
        it: "Il blocco delle maiuscole è attivato!",
      },
      loginSprachvariable: {
        de: "Login",
        en: "Login",
        fr: "Connexion",
        it: "Accesso",
      },
      forgottenyourpassword: {
        de: "Passwort vergessen?",
        en: "Forgotten your password?",
        fr: "Mot de passe oublié ?",
        it: "Avete dimenticato la password?",
      },
      loginFailed: {
        de: "Benutzername oder Passwort ist falsch.",
        en: "Username or password is incorrect.",
        fr: "Nom d'utilisateur ou mot de passe incorrect.",
        it: "Nome utente o password errati.",
      },
    };
  },
  created() {
    window.addEventListener("keyup", (event) => {
      if (event.key === "Enter" && this.username && this.password) {
        this.login();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("keyup");
  },
  computed: {
    loginUrl() {
      return "/login/";
    },
    isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
    serverUrl() {
      return process.env.VUE_APP_SERVER_URL || "–";
    },
    passkeySupported() {
      return isPasskeySupported() && this.passkeyMfaEnabled;
    },
  },
  methods: {
    checkCapsLock(event) {
      this.isCapsLockOn = event.getModifierState("CapsLock");
    },
    async login() {
      this.loggingIn = true;
      this.loginError = false;
      try {
        // Step 1: CMS password login — identical to original flow, creates a proven session.
        const params = new URLSearchParams();
        params.append("username", this.username);
        params.append("password", this.password);
        await axios.post("/login/", params);

        // Step 2: MFA check — returns nextStep; downgrades session if passkey is required.
        const mfaRes = await PublicAppApi.post("passkey/mfa-check");
        const nextStep = mfaRes.data.nextStep;

        if (nextStep === "mfa_choice") {
          this.mfaMethods = mfaRes.data.methods || [];
          this.showMfaChoice = true;
        } else if (nextStep === "passkey_verify") {
          this.showPasskeyVerify = true;
        } else if (nextStep === "passkey_setup") {
          this.showPasskeySetup = true;
        } else if (nextStep === "totp_verify") {
          this.showTotpVerify = true;
        } else if (nextStep === "totp_setup") {
          this.showTotpSetup = true;
        } else {
          this.goToApp();
        }
      } catch (error) {
        this.loginError = true;
      } finally {
        this.loggingIn = false;
      }
    },
    goToApp() {
      let startseite = this.$router.resolve({ name: "ERP Startseite" });
      window.location.href = startseite.href;
    },
    async verifyPasskey() {
      this.passkeyLoading = true;
      this.passkeyError = false;
      try {
        const startRes = await PublicAppApi.post("passkey/authenticate");
        const { challenge, rpId, allowCredentials } = startRes.data;
        const credential = await navigator.credentials.get({
          publicKey: {
            challenge: base64urlToBuffer(challenge),
            rpId,
            allowCredentials: (allowCredentials || []).map((id) => ({
              type: "public-key",
              id: base64urlToBuffer(id),
            })),
            timeout: 60000,
            userVerification: "preferred",
          },
        });
        await PublicAppApi.put("passkey/authenticate", {
          id: credential.id,
          rawId: bufferToBase64url(credential.rawId),
          clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
          authenticatorData: bufferToBase64url(credential.response.authenticatorData),
          signature: bufferToBase64url(credential.response.signature),
          userHandle: credential.response.userHandle
            ? bufferToBase64url(credential.response.userHandle)
            : null,
        });
        this.goToApp();
      } catch (e) {
        if (e.name !== "NotAllowedError") this.passkeyError = true;
      } finally {
        this.passkeyLoading = false;
      }
    },
    async verifyPasskeyOtherDevice() {
      this.passkeyLoading = true;
      this.passkeyError = false;
      try {
        const startRes = await PublicAppApi.post("passkey/authenticate");
        const { challenge, rpId } = startRes.data;
        const credential = await navigator.credentials.get({
          publicKey: {
            challenge: base64urlToBuffer(challenge),
            rpId,
            allowCredentials: [],   // empty = any discoverable credential
            hints: ["hybrid"],      // WebAuthn L3: prefer QR code / cross-device flow
            timeout: 120000,
            userVerification: "preferred",
          },
        });
        await PublicAppApi.put("passkey/authenticate", {
          id: credential.id,
          rawId: bufferToBase64url(credential.rawId),
          clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
          authenticatorData: bufferToBase64url(credential.response.authenticatorData),
          signature: bufferToBase64url(credential.response.signature),
          userHandle: credential.response.userHandle
            ? bufferToBase64url(credential.response.userHandle)
            : null,
        });
        this.goToApp();
      } catch (e) {
        if (e.name !== "NotAllowedError") this.passkeyError = true;
      } finally {
        this.passkeyLoading = false;
      }
    },
    async setupPasskey() {
      this.passkeyLoading = true;
      this.passkeyError = false;
      try {
        const startRes = await PublicAppApi.post("passkey/register");
        const { challenge, rpId, rpName, userId, userName, userDisplayName } = startRes.data;
        const credential = await navigator.credentials.create({
          publicKey: {
            challenge: base64urlToBuffer(challenge),
            rp: { id: rpId, name: rpName },
            user: {
              id: base64urlToBuffer(userId),
              name: userName,
              displayName: userDisplayName,
            },
            pubKeyCredParams: [
              { type: "public-key", alg: -7 },
              { type: "public-key", alg: -257 },
            ],
            timeout: 60000,
            attestation: "none",
            authenticatorSelection: { authenticatorAttachment: "platform", residentKey: "preferred", userVerification: "preferred" },
          },
        });
        await PublicAppApi.put("passkey/register", {
          id: credential.id,
          rawId: bufferToBase64url(credential.rawId),
          clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
          attestationObject: bufferToBase64url(credential.response.attestationObject),
        });
        this.showPasskeySetup = false;
        this.showPasskeyBackup = true;
      } catch (e) {
        if (e.name !== "NotAllowedError") this.passkeyError = true;
      } finally {
        this.passkeyLoading = false;
      }
    },
    async addBackupPasskey() {
      this.passkeyLoading = true;
      this.passkeyError = false;
      try {
        const startRes = await PublicAppApi.post("passkey/register");
        const { challenge, rpId, rpName, userId, userName, userDisplayName } = startRes.data;
        const credential = await navigator.credentials.create({
          publicKey: {
            challenge: base64urlToBuffer(challenge),
            rp: { id: rpId, name: rpName },
            user: {
              id: base64urlToBuffer(userId),
              name: userName,
              displayName: userDisplayName,
            },
            pubKeyCredParams: [
              { type: "public-key", alg: -7 },
              { type: "public-key", alg: -257 },
            ],
            timeout: 120000,
            attestation: "none",
            authenticatorSelection: { authenticatorAttachment: "cross-platform", userVerification: "preferred" },
          },
        });
        await PublicAppApi.put("passkey/register", {
          id: credential.id,
          rawId: bufferToBase64url(credential.rawId),
          clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
          attestationObject: bufferToBase64url(credential.response.attestationObject),
        });
        this.goToApp();
      } catch (e) {
        if (e.name !== "NotAllowedError") this.passkeyError = true;
      } finally {
        this.passkeyLoading = false;
      }
    },
    chooseMfa(method) {
      this.showMfaChoice = false;
      if (method === "passkey")       this.showPasskeyVerify = true;
      else if (method === "totp")     this.showTotpVerify    = true;
      else if (method === "passkey_setup") this.showPasskeySetup = true;
      else if (method === "totp_setup")    this.showTotpSetup    = true;
    },
    async loginWithPasskey() {
      this.passkeyLoading = true;
      this.passkeyError = false;
      this.loginError = false;
      try {
        const startRes = await PublicAppApi.post("passkey/authenticate");
        const { challenge, rpId } = startRes.data;
        const credential = await navigator.credentials.get({
          publicKey: {
            challenge: base64urlToBuffer(challenge),
            rpId,
            allowCredentials: [],
            timeout: 60000,
            userVerification: "preferred",
          },
        });
        await PublicAppApi.put("passkey/authenticate", {
          id: credential.id,
          rawId: bufferToBase64url(credential.rawId),
          clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
          authenticatorData: bufferToBase64url(credential.response.authenticatorData),
          signature: bufferToBase64url(credential.response.signature),
          userHandle: credential.response.userHandle
            ? bufferToBase64url(credential.response.userHandle)
            : null,
        });
        this.goToApp();
      } catch (e) {
        if (e.name !== "NotAllowedError") this.passkeyError = true;
      } finally {
        this.passkeyLoading = false;
      }
    },
    async startTotpSetup() {
      this.totpLoading = true;
      this.totpError = false;
      try {
        const res = await PublicAppApi.post("totp/setup");
        this.totpSecret = res.data.secret;
        this.totpOtpauthUri = res.data.otpauthUri;
        this.$nextTick(async () => {
          const QRCode = (await import("qrcode")).default;
          await QRCode.toCanvas(this.$refs.totpQrCanvas, this.totpOtpauthUri, { width: 200 });
        });
      } catch (e) {
        this.totpError = true;
      } finally {
        this.totpLoading = false;
      }
    },
    async confirmTotpSetup() {
      this.totpLoading = true;
      this.totpError = false;
      try {
        await PublicAppApi.put("totp/setup", { code: this.totpCode });
        this.goToApp();
      } catch (e) {
        this.totpError = true;
        this.totpCode = "";
      } finally {
        this.totpLoading = false;
      }
    },
    async verifyTotp() {
      this.totpLoading = true;
      this.totpError = false;
      try {
        await PublicAppApi.post("totp/verify", { code: this.totpCode });
        this.goToApp();
      } catch (e) {
        this.totpError = true;
        this.totpCode = "";
      } finally {
        this.totpLoading = false;
      }
    },
    navigateToResetPW() {
      this.$router.push({
        name: "resetpassword",
        query: {
          lang: this.language,
        },
      });
    },
  },
  async mounted() {
    this.language =
      this.$route.query.lang || navigator.language || navigator.userLanguage;
    this.language = this.language.slice(0, 2);
    if (
      this.language !== "de" &&
      this.language !== "en" &&
      this.language !== "fr" &&
      this.language !== "it"
    ) {
      this.language = "de";
    }
    try {
      const res = await PublicAppApi.get("mfa-config");
      this.passkeyMfaEnabled = res.data.passkeyEnabled === true;
    } catch {
      // config fetch failure is non-fatal — button stays hidden
    }
  },
};
</script>

<style lang="scss" scoped>
.form-signin {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 400px;
  padding: 15px;
}

.language-selection button {
  width: 30px;
}
</style>
